/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BinaryFileType } from '../../models/binary-file-type';
import { ConsigneeAttachmentResponse } from '../../models/consignee-attachment-response';
import { KeyType } from '../../models/key-type';
import { NameType } from '../../models/name-type';

export interface PostConsigneeDiscrepancyImageToDeliveryNote$Jpeg$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;

/**
 * The delivery note key
 */
  deliveryNoteKey: KeyType;
  fileName: NameType;
      body: BinaryFileType
}

export function postConsigneeDiscrepancyImageToDeliveryNote$Jpeg(http: HttpClient, rootUrl: string, params: PostConsigneeDiscrepancyImageToDeliveryNote$Jpeg$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsigneeAttachmentResponse>> {
  const rb = new RequestBuilder(rootUrl, postConsigneeDiscrepancyImageToDeliveryNote$Jpeg.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.path('fileName', params.fileName, {});
    rb.body(params.body, 'image/jpeg');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsigneeAttachmentResponse>;
    })
  );
}

postConsigneeDiscrepancyImageToDeliveryNote$Jpeg.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/discrepancy-images/file/{fileName}';
